<p-toast></p-toast>
<div class="body">
    <app-left-menu></app-left-menu>
    <div class="apps-right">
        <div class="page-container">
            <div class="inner-page-container">
                <div class="white">
                    <div class="page-title">
                        <div class="row">
                            <div class="col-md-5">
                                <h3>Service Locations & Operation Requirements</h3>
                            </div>
                            <div class="col-md-7 text-right">
                                <div class="action-btn">
                                    <button pButton pRiple icon="pi pi-search" title="Back to Search"
                                        class="p-button p-button-success p-mr-2" (click)="goBack($event)"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-container scroll-y">
                        <!-- <p-tabView  [(activeIndex)]="selectedtab">
                            <p-tabPanel header="Customer Details"> -->
                        <table class="normal-table">
                            <tr>


                                <td style="width:17%" class="text-right">
                                    Temp Customer <span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <div class="p-inputgroup">
                                        <input type="text" disabled pInputText>
                                        <button class="p-inputgroup-addon p-button" title="Add" type="button"
                                            (click)="showBasicDialog()">
                                            <i class="las la-search"></i>
                                        </button>
                                    </div>

                                </td>
                                <td class="text-right">Temp Customer Site <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td class="text-right">Service Locations <span class="hlt-txt">*</span></td>
                                <td>
                                    <!-- <p-dropdown [autoDisplayFirst]="false" placeholder="Select" [filter]="true"
                                        [options]="_ServiceLocation" optionValue="locationid" optionLabel="locationname">
                                    </p-dropdown> -->

                                    <p-multiSelect  [options]="_ServiceLocation" placeholder="Select" optionValue="locationid"  optionLabel="locationname"></p-multiSelect>
                                </td>
                                <td class="text-right">Tier Location <span class="hlt-txt">*</span></td>
                                <td>
                                    <p-dropdown [autoDisplayFirst]="false" placeholder="Select" [filter]="true"
                                    [options]="_Tier" optionValue="tierid" optionLabel="tiername">
                                </p-dropdown>
                                </td>
                                <td class="text-right">POD Requirement <span class="hlt-txt">*</span></td>
                                <td>
                                    <p-dropdown [autoDisplayFirst]="false" placeholder="Select" [filter]="true"
                                    [options]="_Requirments" optionValue="podid" optionLabel="podname">
                                </p-dropdown>
                                </td>

                            </tr>

                            <tr>
                                <td class="text-right">Booking Cut-off Time <span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <p-calendar [timeOnly]="true" inputId="timeonly"></p-calendar>
                                </td>
                                <td class="text-right">Vehicle Departure Cut-off Time*<span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <p-calendar [timeOnly]="true" inputId="timeonly"></p-calendar>
                                </td>
                                <td class="text-right">Pickup Cut-off Time <span class="hlt-txt">*</span></td>
                                <td>
                                    <p-calendar [timeOnly]="true" inputId="timeonly"></p-calendar>
                                </td>

                            </tr>
                            <tr>
                                <td class="text-right">ODA Locations <span class="hlt-txt">*</span></td>
                                <td>
                                    <div class="p-field-radiobutton">
                                        <p-radioButton name="yes" value="yes" inputId="1" label="Yes"></p-radioButton>

                                        <p-radioButton name="no" value="no" inputId="2" label="No"></p-radioButton>
                                    </div>
                                </td>
                                <td class="text-right">Customer LR Copy <span class="hlt-txt">*</span></td>
                                <td>
                                    <div class="p-field-radiobutton">
                                        <p-radioButton name="yes" value="yes" inputId="1" label="Yes"></p-radioButton>

                                        <p-radioButton name="no" value="no" inputId="2" label="No"></p-radioButton>
                                    </div>
                                </td>
                                <td class="text-right">Invoice Acknowledgement <span class="hlt-txt">*</span></td>
                                <td>
                                    <div class="p-field-radiobutton">
                                        <p-radioButton name="yes" value="yes" inputId="1" label="Yes"></p-radioButton>

                                        <p-radioButton name="no" value="no" inputId="2" label="No"></p-radioButton>
                                    </div>
                                </td>

                            </tr>
                            <tr>
                                <td class="text-right">Return Booking Need <span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <div class="p-field-radiobutton">
                                        <p-radioButton name="yes" value="yes" inputId="1" label="Yes"></p-radioButton>

                                        <p-radioButton name="no" value="no" inputId="2" label="No"></p-radioButton>
                                    </div>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>

                        </table>
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Special Delivery</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <!-- <p-tabView [(activeIndex)]="selectedtab">
                            <p-tabPanel header="Pickup Address"> -->
                        <table class="normal-table">
                            <tr>
                                <td class="text-right">Special Delivery <span class="hlt-txt">*</span></td>
                                <td>
                                    <p-dropdown [autoDisplayFirst]="false" placeholder="Select" [filter]="true"
                                    [options]="_SpecialDelivery" optionValue="deliveryid" optionLabel="deliveryname">
                                </p-dropdown>
                                </td>
                                <td class="text-right">Attachment<span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <input name="file-upload-field" type="file" class="file-upload-field"  placeholder="Upload file" accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"> 
                                    <!-- <div class="p-inputgroup">
                                        <span class="p-float-label">
                                            <div class="browse-links"> -->
                                                <!-- <p-button label="Link" styleClass="p-button-link"></p-button> -->
                                            <!-- </div>
                                        </span>
                                        <p-fileUpload class="p-inputgroup-addon p-button p-button-icon-only"
                                            pTooltip="Browse File" tooltipPosition="top" mode="basic" name="demo[]"
                                            accept="image/*" maxFileSize="1000000" chooseLabel="" #fileUpload>
                                        </p-fileUpload>
                                        <button class="p-inputgroup-addon p-button" pTooltip="Cancel"
                                            tooltipPosition="top">
                                            <i class="las la-times"></i>
                                        </button>
                                    </div> -->
                                </td>
                                <td colspan="2">
                                    <button pButton label="Validate Uploaded Data" class="p-button-success"></button>
                                    <button pButton label="Download Template" class="p-button-success"></button>
                                </td>
                               
                            </tr>


                            <tr>
                                <td class="text-right">Consignee Name <span class="hlt-txt">*</span>
                                </td>
                                <td><input type="text" pInputText></td>
                                <td class="text-right">Mobile No. <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                                <td class="text-right">Email ID <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>
                            </tr>
                            <tr>
                                <td class="text-right">Address <span class="hlt-txt">*</span></td>
                                <!-- <td rowspan="2"><textarea inputId="textarea" rows="2" cols="30" pInputTextarea></textarea></td> -->
                                <td><input type="text" pInputText></td>

                                <!--td class="text-right">State <span class="hlt-txt">*</span></td>
                                <td>
                                    <p-dropdown [autoDisplayFirst]="false" placeholder="Select" [filter]="true" [options]="_State" optionValue="stateid"  optionLabel="statename"></p-dropdown>
                                </td>
                                <td class="text-right">District<span class="hlt-txt">*</span></td>
                                <td>
                                    <p-dropdown [autoDisplayFirst]="false" placeholder="Select" [filter]="true" [options]="_District" optionValue="districtid"  optionLabel="districtname"></p-dropdown>
                                </td>

                               
                            </tr>
                            <tr>

                                <td class="text-right">Taluk<span class="hlt-txt">*</span></td>
                                <td><input type="text" disabled pInputText></td-->
                                <td class="text-right">PinCode <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>
                                <td class="text-right">Pincode Location<span class="hlt-txt">*</span></td>
                                <td>
                                    <p-dropdown [autoDisplayFirst]="false" placeholder="Select" [filter]="true"
                                    >
                                </p-dropdown>
                                </td>
                            </tr>
                            <tr>
                                <!-- <td class="text-right">City <span class="hlt-txt">*</span></td>
                                        <td><input type="text" pInputText> </td> -->

                                <td class="text-right">Floor<span class="hlt-txt">*</span></td>
                                    <td><p-dropdown [autoDisplayFirst]="false" placeholder="Select" [filter]="true" [options]="_FloorType" optionValue="floorid"  optionLabel="floorname"></p-dropdown></td>
                                <!-- <td class="text-right">Email ID <span class="hlt-txt">*</span></td>
                                         <td><input type="text" pInputText></td> -->

                                <!--  </tr>
                                   
                                    <tr>
                                        <td class="text-right">Billing Cycle <span class="hlt-txt">*</span></td>
                                        <td><input type="text" pInputText></td> -->
                                <!-- <td class="text-right">Billing to <span class="hlt-txt">*</span></td>
                                        <td><input type="text" pInputText></td> -->
                                <!-- <td class="text-right">Pickup Floor Type <span class="hlt-txt">*</span></td>
                                        <td><input type="text" pInputText></td> -->

                            </tr>
                            <tr>
                                <td></td>
                                <td></td>

                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colspan="6" class="text-center">
                                    <button pButton label="Add" class="p-button-success"></button>
                                    <button pButton label="Clear" class="p-button-warning"></button>
                                </td>
                            </tr>
                        </table>
                        <div class="card">
                            <p-toolbar styleClass="p-mb-4">
                                <ng-template pTemplate="left">
                                    <span class="p-input-icon-left">
                                        <i class="las la-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </ng-template>

                                <ng-template pTemplate="right">
                                    <button type="button" pButton pRipple icon="las la-file-excel"
                                        title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                        tooltipPosition="bottom"></button>
                                </ng-template>
                            </p-toolbar>

                            <!-- <p-table #dt [value]="ManageCustomersList" [scrollable]="true" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']" [style]="{'overflow':'auto!important'}"
                                        [rowHover]="true" dataKey="id"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [showCurrentPageReport]="true" > -->

                            <p-table #dt [value]="SpecialDeliveryList" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['LEVELNAME','markuppercentage','vatpercentage','USD','CAD','ZAR','Currency4','Currency5']"
                                [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true">

                                <!-- <ng-template pTemplate="colgroup" let-columns>
                                            <colgroup>
                                                <col style="width:250px">
                                                <col style="width:250px">
                                                <col style="width:250px">
                                                <col style="width:150px">
                                                <col style="width:250px">
                                                <col style="width:250px">
                                                <col style="width: 100px">
                                                <col style="width:150px">
                                                <col style="width:250px">
                                                <col style="width:250px">
                                                <col style="width:250px">
                                                <col style="width:250px">
                                                <col style="width:250px">
                                                <col style="width:250px">
                                            </colgroup>
                                        </ng-template> -->
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="text-align: center;" style="width: 6%;">Action</th>

                                        <th pSortableColumn="agentNo"  style="width: 12%;"> Special Delivery<p-sortIcon field="agentNo">
                                            </p-sortIcon>
                                        </th>
                                        
                                        <th pSortableColumn="agentNo" style="width: 12%;">Consignee Name <p-sortIcon field="agentNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName"  style="width: 9%;">Mobile No <p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="fatherName"  style="width: 8%;">Email ID <p-sortIcon field="fatherName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo"  style="width: 8%;">Address <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo"  style="width: 7%;">Floor <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <!--th pSortableColumn="mobileNo"  style="width: 7%;">State <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo"  style="width: 6%;">City <p-sortIcon field="mobileNo"></p-sortIcon>
                                        </th-->
                                        <th pSortableColumn="mobileNo"  style="width: 8%;">PinCode <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo" style="width: 13%;">Pincode Location <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <!-- <th pSortableColumn="mobileNo">State <p-sortIcon field="mobileNo"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                                    </p-sortIcon>
                                                </th> -->
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-_ManageCustomerList>
                                    <tr>
                                        <td>
                                            <!-- <button pButton pRipple title="Add" icon="pi pi-plus"
                                                        class="p-button-success p-mr-2" 
                                                        ></button> -->
                                            <button pButton pRipple title="Remove" icon="pi pi-trash"
                                                class="p-button-danger p-mr-2"></button>
                                        </td>

                                        <td>
                                            {{_ManageCustomerList.customername}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.customername}}
                                        </td>
                                      
                                        <td>
                                            {{_ManageCustomerList.customertallyid}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.customertype}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.istranspoter}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.panno}}
                                        </td>
                                        <!--td>
                                            {{_ManageCustomerList.billingcycle}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.status}}
                                        </td-->
                                        <td>
                                            {{_ManageCustomerList.status}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.status}}
                                        </td>
                                        <!-- <td>
                                                    {{_ManageCustomerList.mobileNo}}
                                                </td>
                                                <td>
                                                    {{_ManageCustomerList.mobileNo}}
                                                </td>
                                                <td>
                                                    {{_ManageCustomerList.mobileNo}}
                                                </td>
                                                <td>
                                                    {{_ManageCustomerList.mobileNo}}
                                                </td>
                                                <td>
                                                    {{_ManageCustomerList.mobileNo}}
                                                </td>
                                                <td>
                                                    {{_ManageCustomerList.mobileNo}}
                                                </td>
                                                <td>
                                                    {{_ManageCustomerList.mobileNo}}
                                                </td> -->
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <!-- </p-tabPanel>
                            <p-tabPanel header="Billing Address"> -->

                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>TAT Details</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <table class="normal-table">
                            <tr>
                                <td style="width:17%" class="text-right">
                                    TAT Based on <span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <p-dropdown [autoDisplayFirst]="false" placeholder="Select" [filter]="true"
                                    [options]="_TatBased" optionValue="tatid" optionLabel="tatname">
                                </p-dropdown>
                                </td>
                                <td class="text-right">Upload TAT Document <span class="hlt-txt">*</span></td>
                                <td>
                                    <input name="file-upload-field" type="file" class="file-upload-field"  placeholder="Upload file" accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"> 
                                </td>
                                <td colspan="2">
                                    <button pButton label="Validate Uploaded Data" class="p-button-success"></button>
                                    <button pButton label="Download Template" class="p-button-success"></button>
                                </td>
                               
                            </tr>
                            <tr>
                                <td style="width:17%" class="text-right">
                                    From Location <span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <input type="text" pInputText>
                                </td>
                                <td class="text-right">To Location <span class="hlt-txt">*</span></td>
                                <td>
                                    <input type="text" pInputText>
                                </td>
                                <td class="text-right">TAT (in Days) <span class="hlt-txt">*</span></td>
                                <td>
                                    <input type="text" pInputText>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="6" class="text-center">
                                    <button pButton label="Add" class="p-button-success"></button>
                                    <button pButton label="Clear" class="p-button-warning"></button>
                                </td>
                            </tr>

                        </table>
                        <div class="card">
                            <p-toolbar styleClass="p-mb-4">
                                <ng-template pTemplate="left">
                                    <span class="p-input-icon-left">
                                        <i class="las la-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </ng-template>

                                <ng-template pTemplate="right">
                                    <button type="button" pButton pRipple icon="las la-file-excel"
                                        title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                        tooltipPosition="bottom"></button>
                                </ng-template>
                            </p-toolbar>

                            <!-- <p-table #dt [value]="ManageCustomersList" [scrollable]="true" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']" [style]="{'overflow':'auto!important'}"
                                [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true" > -->

                            <p-table #dt [value]="SpecialDeliveryList" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['LEVELNAME','markuppercentage','vatpercentage','USD','CAD','ZAR','Currency4','Currency5']"
                                [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true">

                                <!-- <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:150px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width: 100px">
                                        <col style="width:150px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                    </colgroup>
                                </ng-template> -->
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="text-align: center;width: 100px;">Action</th>
                                        <th pSortableColumn="agentNo">From Location <p-sortIcon field="agentNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">To location <p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="fatherName">TAT(in Days)<p-sortIcon field="fatherName">
                                            </p-sortIcon>
                                        </th>


                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-_ManageCustomerList>
                                    <tr>
                                        <td>
                                            <button pButton pRipple title="Remove" icon="pi pi-trash"
                                                class="p-button-danger p-mr-2"></button>
                                        </td>

                                        <td>
                                            {{_ManageCustomerList.customername}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.customertallyid}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.customertype}}
                                        </td>

                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Comments</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <table class="normal-table">

                            <tr>
                                <td class="text-right">Comments<span class="hlt-txt">*</span></td>
                                <!-- <td> -->
                                <td colspan="5"><textarea inputId="textarea" rows="2" cols="30"
                                        pInputTextarea></textarea></td>
                            </tr>
                            <tr>
                                <td colspan="6" class="text-center">
                                    <button pButton label="Save" class="p-button-success" icon="las la-check"></button>
                                    <button pButton label="Clear" class="p-button-warning" icon="las la-broom"></button>
                                </td>
                            </tr>
                        </table>
                        <p-dialog header="Customer" [(visible)]="displayBasic" [modal]="true"
                            [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                            <ng-template pTemplate="content">
                                <div class="popup-body">
                                    <div class="search-container">
                                        <div class="p-inputgroup">
                                            <span class="p-float-label">
                                                <input type="text" id="inputtext" pInputText>
                                            </span>
                                            <button class="p-inputgroup-addon p-button" title="Search">
                                                <i class="pi pi-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <p-table [value]="_Expenses" selectionMode="single"
                                            [(selection)]="selectedRequest" (onRowSelect)="onRowSelectPopup($event)"
                                            (onRowUnselect)="onRowUnSelectPopup($event)" [paginator]="true" [rows]="10">
                                            <ng-template pTemplate="header">
                                                <tr>
                                                    <!-- <th *ngIf="_action != 'view'">
                                                </th> -->
                                                    <th pSortableColumn="requestno">Customer Name <p-sortIcon
                                                            field="requestno">
                                                        </p-sortIcon>
                                                    </th>
                                                    <!-- <th pSortableColumn="requestedbranch">Customer Tally ID
                                                        <p-sortIcon field="requestedbranch">
                                                        </p-sortIcon>
                                                    </th> -->
                                                    <th pSortableColumn="requestperson">Customer Type <p-sortIcon
                                                            field="requestperson">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="requestedbranch">Is Transporter
                                                        <p-sortIcon field="requestedbranch">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="requestedbranch">Billing Cycle
                                                        <p-sortIcon field="requestedbranch">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="requestedbranch">Pan No
                                                        <p-sortIcon field="requestedbranch">
                                                        </p-sortIcon>
                                                    </th>


                                                </tr>
                                            </ng-template>
                                            <ng-template pTemplate="body" let-rowData let-_Expense>
                                                <tr>
                                                    <!-- <td style="text-align: center" *ngIf="_action != 'view'">
                                                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                                                </td> -->
                                                    <td>{{_Expense.pettycashsettlementid}}</td>
                                                    <td>{{_Expense.settlementamount}}</td>
                                                    <!-- <td>{{_Expense.balanceamount}}</td> -->
                                                    <td>{{_Expense.settlementamount}}</td>
                                                    <td>{{_Expense.balanceamount}}</td>
                                                    <td>{{_Expense.balanceamount}}</td>

                                                </tr>
                                            </ng-template>
                                        </p-table>
                                    </div>
                                </div>
                            </ng-template>
                        </p-dialog>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>